import { User } from "../pages/shared/models/user/user";
import axiosInstance from "../router/interceptor";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:4001/bls";

async function register(newUser: User, languageId: number) {
  try {
    return axiosInstance.post(`${API_URL}/users/create`, {
      user: newUser,
      languageId,
    });
  } catch (error) {
    console.error(error);
  }
}

async function createWithJWT(newUser: User) {
  const authorizationHeader = configAuthorizationHeader();

  try {
    return axiosInstance.post(
      `${API_URL}/users/create-with-jwt`,
      { user: newUser },
      authorizationHeader,
    );
  } catch (error) {
    console.error(error);
  }
}

async function registerWithGoogleAccount(
  credentials: string | undefined,
  locationId: number,
  languageId: number,
) {
  try {
    return axiosInstance.post(`${API_URL}/users/create?gc=true`, {
      credentials,
      locationId,
      languageId,
    });
  } catch (error) {
    console.error(error);
  }
}

async function confirmUser(token: string | undefined) {
  try {
    return axiosInstance.post(`${API_URL}/users/confirm/${token}`);
  } catch (error) {
    console.error(error);
  }
}

async function login(email: string, password: string) {
  try {
    return axiosInstance.post(`${API_URL}/auth`, {
      email,
      password,
    });
  } catch (error) {
    console.error(error);
  }
}

async function loginWithGoogleAccount(credentials: string | undefined) {
  try {
    return axiosInstance.post(`${API_URL}/auth?gc=true`, { credentials });
  } catch (error) {
    console.error(error);
  }
}

async function recoverPassword(email: string | undefined, languageId: number) {
  try {
    return axiosInstance.put(`${API_URL}/users/forgot-password`, {
      email,
      languageId,
    });
  } catch (error) {
    console.error(error);
  }
}

async function confirmResetToken(token: string) {
  try {
    return axiosInstance.post(`${API_URL}/users/confirm-reset-password`, {
      token,
    });
  } catch (error) {
    console.error(error);
  }
}

async function resetPassword(
  password: string | undefined,
  token?: string | null,
) {
  try {
    return axiosInstance.post(`${API_URL}/users/reset-password`, {
      password,
      token,
    });
  } catch (error) {
    console.error(error);
  }
}

function configAuthorizationHeader() {
  let token = localStorage.getItem("access_token");
  const refreshToken = localStorage.getItem("refresh_token");
  token = token ? token.replaceAll('"', "") : "";
  return {
    headers: {
      Authorization: "Bearer ".concat(token),
      "x-refresh-token": refreshToken,
    },
  };
}

export default {
  register,
  createWithJWT,
  registerWithGoogleAccount,
  login,
  loginWithGoogleAccount,
  confirmUser,
  recoverPassword,
  confirmResetToken,
  resetPassword,
};
